import React from 'react';
import { List } from '@web/molecules';
import { SplitScreenListBody } from '@web/components';
import checkIcon from '../images/Icons/Check.png';
import splitScreenPromoImage from '../images/our-food/split_screen_promo_image.jpg';
import dryChickenImage from '../images/our-food/chicken-baked-bag.png';
import dryBeefImage from '../images/our-food/beef-baked-bag.png';
import freshRecipesImage from '../images/recipes/types/fresh-bowl.png';
import halfFreshRecipesImage from '../images/recipes/types/half-fresh-bowl.png';
import mixedRecipesImage from '../images/recipes/types/mixed-bowl.png';
import freshPlanImage from '../images/product-photos/pack-shots/fresh_food_packs.png';
import mixedPlanImage from '../images/product-photos/pack-shots/mixed_food_packs.png';
import beefPack from '../images/our-food/new-beef-pack.png';
import chickenPack from '../images/our-food/new-chicken-pack.png';
import porkPack from '../images/our-food/pork-pack.png';
import lambPack from '../images/our-food/new-lamb-pack.png';
import turkeyPack from '../images/our-food/new-turkey-pack.png';
import beefBowl from '../images/product-photos/bowls/fresh-beef-bowl-transparent.png';
import chickenBowl from '../images/product-photos/bowls/fresh-chicken-bowl-transparent.png';
import turkeyBowl from '../images/product-photos/bowls/fresh-turkey-bowl-transparent.png';
import lambBowl from '../images/product-photos/bowls/fresh-lamb-bowl-transparent.png';
import porkBowl from '../images/product-photos/bowls/fresh-pork-bowl-transparent.png';

export const MEAL_PREP_TYPES = ['fresh', 'half_fresh', 'baked', 'mixed'];

// Recipes
export const recipes = [
  {
    title: 'Fresh Beef',
    label: 'Add',
    value: 'beef',
    benefit: 'Vitamin-Rich',
    description: 'With sweet potatoes',
    img: {
      src: beefBowl.src,
      alt: 'beef recipe',
      width: 82,
      height: 82,
    },
    priceSymbol: 'low',
    UnavailableText:
      'Interested in our Fresh Beef Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Turkey',
    label: 'Add',
    value: 'turkey',
    description: 'With Blueberries',
    benefit: 'Antioxidant Rich',
    img: {
      src: turkeyBowl.src,
      alt: 'turkey recipe',
      width: 82,
      height: 82,
    },
    UnavailableText:
      'Interested in our Fresh Turkey Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    priceSymbol: 'mid',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Chicken',
    label: 'Add',
    value: 'chicken',
    benefit: 'Sensitive Bellies',
    description: 'With Carrots',
    img: {
      src: chickenBowl.src,
      alt: 'chicken recipe',
      width: 82,
      height: 82,
    },
    priceSymbol: 'mid',
    UnavailableText:
      'Interested in our Fresh Chicken Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Lamb',
    label: 'Add',
    value: 'lamb',
    benefit: 'Allergy-Friendly',
    description: 'With Cranberries',
    img: {
      src: lambBowl.src,
      alt: 'lamb recipe',
      width: 82,
      height: 82,
    },
    priceSymbol: 'high',
    UnavailableText:
      'Interested in our Fresh Lamb Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Pork',
    label: 'Add',
    value: 'pork',
    description: 'With Apples',
    img: {
      src: porkBowl.src,
      alt: 'pork recipe',
      width: 82,
      height: 82,
    },
    benefit: 'Light and Lean',
    callout: 'New',
    priceSymbol: 'low',
    UnavailableText:
      'Interested in our Fresh Pork Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
];

export const optimizedRecipes = [
  {
    title: 'Fresh Beef',
    label: 'Add',
    value: 'beef',
    benefit: 'Vitamin-Rich',
    description: 'with Sweet potatoes',
    img: {
      src: beefPack.src,
      alt: 'beef recipe',
      width: 88,
      height: 65,
    },
    priceSymbol: 'low',
    UnavailableText:
      'Interested in our Fresh Beef Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Turkey',
    label: 'Add',
    value: 'turkey',
    description: 'with Blueberries',
    benefit: 'Antioxidant Rich',
    img: {
      src: turkeyPack.src,
      alt: 'turkey recipe',
      width: 88,
      height: 65,
    },
    UnavailableText:
      'Interested in our Fresh Turkey Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    priceSymbol: 'mid',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Chicken',
    label: 'Add',
    value: 'chicken',
    benefit: 'Sensitive Bellies',
    description: 'with Carrots',
    img: {
      src: chickenPack.src,
      alt: 'chicken recipe',
      width: 88,
      height: 65,
    },
    priceSymbol: 'mid',
    UnavailableText:
      'Interested in our Fresh Chicken Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Lamb',
    label: 'Add',
    value: 'lamb',
    benefit: 'Allergy-Friendly',
    description: 'with Cranberries',
    img: {
      src: lambPack.src,
      alt: 'lamb recipe',
      width: 88,
      height: 65,
    },
    priceSymbol: 'high',
    UnavailableText:
      'Interested in our Fresh Lamb Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Pork',
    label: 'Add',
    value: 'pork',
    description: 'with Apples',
    img: {
      src: porkPack.src,
      alt: 'pork recipe',
      width: 88,
      height: 65,
    },
    benefit: 'Light and Lean',
    callout: 'New',
    priceSymbol: 'low',
    UnavailableText:
      'Interested in our Fresh Pork Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
];

export const carouselFormRecipes = [
  {
    title: 'Fresh Beef',
    label: 'Add',
    value: 'beef',
    benefit: 'Vitamin-Rich',
    description: 'w/ Sweet potatoes',
    img: {
      src: beefPack.src,
      alt: 'beef recipe',
      width: 88,
      height: 65,
    },
    priceSymbol: 'low',
    UnavailableText:
      'Interested in our Fresh Beef Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Turkey',
    label: 'Add',
    value: 'turkey',
    description: 'w/ Blueberries',
    benefit: 'Antioxidant Rich',
    img: {
      src: turkeyPack.src,
      alt: 'turkey recipe',
      width: 88,
      height: 65,
    },
    UnavailableText:
      'Interested in our Fresh Turkey Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    priceSymbol: 'mid',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Chicken',
    label: 'Add',
    value: 'chicken',
    benefit: 'Sensitive Bellies',
    description: 'w/ Carrots',
    img: {
      src: chickenPack.src,
      alt: 'chicken recipe',
      width: 88,
      height: 65,
    },
    priceSymbol: 'mid',
    UnavailableText:
      'Interested in our Fresh Chicken Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Lamb',
    label: 'Add',
    value: 'lamb',
    benefit: 'Allergy-Friendly',
    description: 'w/ Cranberries',
    img: {
      src: lambPack.src,
      alt: 'lamb recipe',
      width: 88,
      height: 65,
    },
    priceSymbol: 'high',
    UnavailableText:
      'Interested in our Fresh Lamb Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Fresh Pork',
    label: 'Add',
    value: 'pork',
    description: 'w/ Apples',
    img: {
      src: porkPack.src,
      alt: 'pork recipe',
      width: 88,
      height: 65,
    },
    benefit: 'Light and Lean',
    callout: 'New',
    priceSymbol: 'low',
    UnavailableText:
      'Interested in our Fresh Pork Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
];

export const dryRecipes = [
  {
    title: 'Baked Chicken',
    label: 'Add',
    value: 'chicken',
    description: 'with Carrots',
    img: {
      src: dryChickenImage.src,
      alt: 'chicken recipe',
    },
    showMoreDetails: true,
  },
  {
    title: 'Baked Beef',
    label: 'Add',
    value: 'beef',
    description: 'with Sweet potatoes',
    img: {
      src: dryBeefImage.src,
      alt: 'beef recipe',
    },
    showMoreDetails: true,
  },
];

export const planTypes = [
  {
    title: 'Full Fresh',
    label: 'Select',
    value: 'fresh',
    description: '100% Fresh recipes',
    img: {
      src: freshRecipesImage.src,
      alt: 'fresh recipe',
    },
    pricingInfo: {
      discount: '$37.50',
      price: '$75.00/week',
    },
    badge: 'RECOMMENDED',
    showMoreDetails: false,
    carousel_assets: [
      freshRecipesImage,
      freshRecipesImage,
      freshRecipesImage,
      freshRecipesImage,
    ],
  },
  {
    title: 'Mixed',
    label: 'Select',
    value: 'mixed',
    description: 'Fresh and baked',
    img: {
      src: mixedRecipesImage.src,
      alt: 'mixed recipe',
    },
    pricingInfo: {
      discount: '$37.50',
      price: '$75.00/week',
    },
    badge: '',
    showMoreDetails: false,
    carousel_assets: [
      mixedRecipesImage,
      mixedRecipesImage,
      mixedRecipesImage,
      mixedRecipesImage,
    ],
  },
];

export const collapsedPlanTypes = [
  {
    title: 'Half fresh',
    label: 'Select',
    benefit: '',
    callout: '',
    value: 'half_fresh',
    description: (
      <List
        textAlignment="left"
        items={[
          { body: 'Same benefits, smaller portion' },
          { body: 'Mix with current food' },
        ]}
        icon="checkmarkSimple"
        gap={0}
        typography="label"
        iconColor="text.primary"
      />
    ),
    img: {
      src: halfFreshRecipesImage.src,
      alt: 'Mixed Bowl',
    },
    unavailableText:
      'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
    priceSymbol: '',
    showMoreDetails: false,
    pricingInfo: {
      discount: '37.50',
      price: '75.00/week',
    },
    level: 'h3',
    carousel_assets: [
      halfFreshRecipesImage,
      halfFreshRecipesImage,
      halfFreshRecipesImage,
      halfFreshRecipesImage,
    ],
  },
];

// Checkout constants whaddup

export const recurringOrdersProps = {
  foodPacksText:
    //eslint-disable-next-line no-template-curly-in-string
    "After {{pupName}}'s starter box, {{petPronoun}} plan will be billed and shipped every {{frequency}} weeks. ",
};

const commonProps = {
  headerText: "Hmm, something's not right.",
  errorMessage:
    "We weren't able to complete your request, please refresh the page and try again.",
};

export const serverSideErrorModalInfo = {
  onboarding: { ...commonProps },
  mealPlan: { ...commonProps },
  checkout: {
    headerText: "Your payment didn't go through",
    errorMessage: 'Please update your information or try a new payment method.',
  },
};

//mealPlan
export const mealPlanModalContent = [
  {
    title: 'Fresh',
    value: 'fresh',
    description: (
      <List
        items={[
          { body: 'Highest quality fresh ingredients' },
          { body: 'Great tasting, best for picky eaters' },
          { body: 'Increased longevity & visible health benefits' },
        ]}
        icon="checkmarkSimple"
        gap={0}
        typography="label"
        iconColor="secondary.yellow"
      />
    ),
    img: {
      src: freshPlanImage.src,
      alt: 'fresh recipe',
    },
    pricingInfo: {
      price: '{{freshPricePerWeek}}',
      discount: '{{freshDiscountPricePerWeek}}',
    },
    badge: 'popular',
    showMoreDetails: false,
    period: 'week',
  },
  {
    title: 'Mixed',
    value: 'mixed',
    description: (
      <List
        items={[
          { body: 'Gently baked food retains nutrients' },
          { body: 'Health & longevity benefits of Fresh' },
          { body: 'Saves freezer space, easier for travel' },
        ]}
        icon="checkmarkSimple"
        gap={0}
        typography="label"
        iconColor="secondary.yellow"
      />
    ),
    img: {
      src: mixedPlanImage.src,
      alt: 'mixed recipe',
    },
    pricingInfo: {
      price: '{{mixedPricePerWeek}}',
      discount: '{{mixedDiscountPricePerWeek}}',
    },
    badge: 'new',
    showMoreDetails: false,
    period: 'week',
  },
];

const planDescription = [
  {
    heading: 'List item 1',
    body: 'Highest quality fresh ingredients',
  },
  {
    heading: 'List item 2',
    body: 'Great tasting, best for picky eaters',
  },
  {
    heading: 'List item 3',
    body: 'Increased Longevity & visible healty benefits',
  },
];

//Fresh Only Test
export const freshOnlyPlan = [
  {
    title: 'Full Fresh',
    benefit: 'Recommended',
    label: 'Select',
    value: 'fresh',
    description: (
      <>
        <List
          items={planDescription}
          icon="checkmarkSimple"
          gap={0}
          typography="label"
          iconColor="text.primary"
          textAlignment="left"
        />
      </>
    ),
    img: {
      src: freshRecipesImage.src,
      alt: 'fresh recipe',
    },
    pricingInfo: {
      discount: '$37.50',
      price: '$75.00/week',
    },
    badge: 'popular',
    showMoreDetails: false,
    carousel_assets: [
      freshRecipesImage,
      freshRecipesImage,
      freshRecipesImage,
      freshRecipesImage,
    ],
  },
];

const promoIcon = {
  src: checkIcon,
  alt: 'icon image',
  height: 100,
  width: 100,
};

const splitListBodyData = {
  heading: {
    text: 'Benefits of a fresh food diet',
    level: 'h1',
    position: 'center',
    typography: 'heading1',
  },
  fontColor: 'text.primary',
  backgroundColor: 'neutral.cream',
  list: [
    {
      heading: 'IMPROVED DIGESTION & ENERGY',
      promoIcon,
      headingLevel: 'h2',
      body: 'More digestible than kibble, giving your pup more nutrients and pep in their step.',
    },
    {
      heading: 'ALLERGY & WEIGHT CONTROL',
      promoIcon,
      headingLevel: 'h2',
      body: "Our food helps maintain your pup's ideal weight and is great for allergies and sensitivities.",
    },
    {
      heading: 'MORE MEALTIMES TOGETHER',
      promoIcon,
      headingLevel: 'h2',
      body: 'A fresh, whole food diet has been proven to help dogs live up to 2.5 years longer.',
    },
  ],
};

export const splitScreenPromoProps = {
  imageFirst: false,
  image: {
    src: splitScreenPromoImage,
    alt: 'Our Recipes',
  },
  contentBgColor: 'neutral.cream',
  content: (
    <>
      <SplitScreenListBody {...splitListBodyData} />
    </>
  ),
  eyebrow: '',
};
